module.exports = __webpack_public_path__ + "static/media/i54.ae5821ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i54.svg
// module id = 526
// module chunks = 8